






import Vue from 'vue';
import {Component} from 'vue-property-decorator';

@Component
export default class ButtonGroup extends Vue {
  mounted(){
    for (const node of this.$el.children){
      const nodeName = node.nodeName.toLowerCase()
      if (nodeName !=='button'){
        console.warn(`Button-group的子元素应该全是 button，而你写的是: ${nodeName}`);
      }
    }
  }
}
